// 雪兰莪州球场数据
// Selangor Golf Courses

export const SELANGOR_COURSES = {
  "AMVERTON_COVE_GOLF_AND_ISLAND_RESORT": {
    shortName: "ACGIR",
    fullName: "Amverton Cove Golf & Island Resort",
    location: ["Carey Island", "Selangor", "Malaysia"],
    pars: [4,5,4,4,3,4,3,5,4, 5,4,3,4,5,4,4,3,4],
    index: [5,1,7,13,15,11,17,3,9, 12,4,14,18,2,10,8,16,6]
  },

  "BANGI_GOLF_RESORT_BANGI_KAJANG": {
    shortName: "BGR-BK",
    fullName: "Bangi Golf Resort (Bangi + Kajang)",
    location: ["Bangi", "Selangor", "Malaysia"],
    pars: [4,4,3,5,3,4,4,4,4, 4,3,5,3,5,4,4,3,5],
    index: [18,4,14,8,12,2,16,10,6, 7,17,13,15,5,1,3,9,11]
  },

  "BANGI_GOLF_RESORT_KAJANG_PUTRAJAYA": {
    shortName: "BGR-KP",
    fullName: "Bangi Golf Resort (Kajang + Putrajaya)",
    location: ["Bangi", "Selangor", "Malaysia"],
    pars: [4,3,5,3,5,4,4,3,5, 4,3,5,4,4,4,3,5,4],
    index: [7,17,13,15,5,1,3,9,11, 12,8,14,16,4,2,18,10,6]
  },

  "BANGI_GOLF_RESORT_BANGI_PUTRAJAYA": {
    shortName: "BGR-BP",
    fullName: "Bangi Golf Resort (Bangi + Putrajaya)",
    location: ["Bangi", "Selangor", "Malaysia"],
    pars: [4,4,3,5,3,4,4,4,4, 4,3,5,4,4,4,3,5,4],
    index: [18,4,14,8,12,2,16,10,6, 11,7,13,15,3,1,17,9,5]
  },

  "BUKIT_BERUNTUNG_GOLF_&_COUNTRY_CLUB": {
    shortName: "BBGCC",
    fullName: "Bukit Beruntung Golf & Country Club",
    location: ["Bukit Beruntung", "Selangor", "Malaysia"],
    pars: [5,3,4,3,4,5,4,4,4, 4,4,5,5,3,4,3,4,4],
    index: [5,11,15,17,13,9,3,7,1, 8,2,10,6,18,16,12,4,14]
  },

  "BUKIT_KEMUNING_GOLF_AND_COUNTRY_CLUB": {
    shortName: "BKGCC",
    fullName: "Bukit Kemuning Golf & Country Club",
    location: ["Shah Alam", "Selangor", "Malaysia"],
    pars: [4,3,5,4,4,3,4,4,5, 4,4,5,3,4,3,5,4,4],
    index: [3,7,15,1,5,13,17,9,11, 12,8,6,18,16,10,4,14,2]
  },

  "Bukit_Unggul_Country_Club": {
    shortName: "BUCC",
    fullName: "Bukit Unggul Country Club",
    location: ["Dengkil", "Selangor", "Malaysia"],
    pars: [4,3,5,4,4,4,3,4,4, 5,4,4,4,3,5,4,3,4],
    index: [17,15,5,9,11,7,13,1,3, 10,2,14,6,18,8,12,16,4]
  },

  "CAREY_ISLAND_GOLF_CLUB": {
    shortName: "CIGC",
    fullName: "Carey Island Golf Club",
    location: ["Carey Island", "Selangor", "Malaysia"],
    pars: [4,4,3,4,5,4,4,3,5, 3,4,4,4,5,3,4,4,4],
    index: [18,12,16,8,2,14,10,4,6, 5,1,9,7,15,3,11,13,17]
  },

  "DANAU_GOLF_CLUB": {
    shortName: "DGC",
    fullName: "Danau Golf Club",
    location: ["Bangi", "Selangor", "Malaysia"],
    pars: [4,4,3,5,4,3,4,4,5, 4,4,5,3,4,5,3,4,4],
    index: [3,9,15,1,7,17,5,11,13, 14,2,6,10,12,18,8,4,16]
  },

  "GLENMARIE_GOLF_AND_COUNTRY_CLUB_GARDEN": {
    shortName: "GGCC-G",
    fullName: "Glenmarie Golf & Country Club (Garden Course)",
    location: ["Shah Alam", "Selangor", "Malaysia"],
    pars: [4,3,5,4,3,5,4,4,4, 4,5,3,4,4,4,5,3,4],
    index: [9,17,15,1,11,3,13,5,7, 12,16,14,2,4,10,6,18,8]
  },

  "GLENMARIE_GOLF_AND_COUNTRY_CLUB_VALLEY": {
    shortName: "GGCC-V",
    fullName: "Glenmarie Golf & Country Club (Valley Course)",
    location: ["Shah Alam", "Selangor", "Malaysia"],
    pars: [4,5,4,3,5,4,4,3,4, 4,4,3,4,5,3,4,4,5],
    index: [1,15,13,17,7,3,5,9,11, 6,16,10,4,8,12,14,2,18]
  },

  "GPA_KELAB_GOLF_PERKHIDMATAN_AWAM_HILLS_FOREST": {
    shortName: "GKGPA-HF",
    fullName: "GPA - Kelab Golf Perkhidmatan Awam (Hills + Forest)",
    location: ["Sungai Buloh", "Selangor", "Malaysia"],
    pars: [4,5,4,3,4,5,3,3,5, 4,4,5,3,4,4,5,3,4],
    index: [4,10,14,18,6,2,12,8,16, 7,13,3,11,1,15,17,9,5]
  },

  "GPA_KELAB_GOLF_PERKHIDMATAN_AWAM_HILLS_LAKES": {
    shortName: "GKGPA-HL",
    fullName: "GPA - Kelab Golf Perkhidmatan Awam (Hills + Lakes)",
    location: ["Sungai Buloh", "Selangor", "Malaysia"],
    pars: [4,5,4,3,4,5,3,3,5, 4,3,5,4,4,3,4,5,4],
    index: [3,9,13,17,5,1,11,7,15, 14,6,2,16,4,12,10,18,8]
  },

  "GPA_KELAB_GOLF_PERKHIDMATAN_AWAM_LAKES_FOREST": {
    shortName: "GKGPA-LF",
    fullName: "GPA - Kelab Golf Perkhidmatan Awam (Lakes + Forest)",
    location: ["Sungai Buloh", "Selangor", "Malaysia"],
    pars: [4,3,5,4,4,3,4,5,4, 4,4,5,3,4,4,5,3,4],
    index: [13,5,1,15,3,11,9,17,7, 8,14,4,12,2,16,18,10,6]
  },

  "ILSAS_RECREATIONAL_GOLF_COURSE": {
    shortName: "IRGC",
    fullName: "ILSAS Recreational Golf Course",
    location: ["Kajang", "Selangor", "Malaysia"],
    pars: [4,4,3,3,4,3,5,3,4],
    index: [4,9,6,8,7,3,2,1,5]
  },

  "IMPIAN_GOLF_AND_COUNTRY_CLUB": {
    shortName: "IGCC",
    fullName: "Impian Golf & Country Club",
    location: ["Kajang", "Selangor", "Malaysia"],
    pars: [4,3,5,4,5,4,3,4,4, 4,4,3,4,5,4,3,5,4],
    index: [11,9,13,1,3,17,15,5,7, 12,10,14,4,8,2,18,16,6]
  },

  "KAJANG_HILL_GOLF_CLUB": {
    shortName: "KHGC",
    fullName: "Kajang Hill Golf Club",
    location: ["Semenyih", "Selangor", "Malaysia"],
    pars: [5,4,4,3,5,3,4,4,4, 4,3,4,5,3,4,5,4,4],
    index: [7,15,5,13,9,17,1,11,3, 10,12,4,2,18,14,8,16,6]
  },

  "KELAB_DARUL_EHSAN": {
    shortName: "KDE",
    fullName: "Kelab Darul Ehsan",
    location: ["Ampang", "Selangor", "Malaysia"],
    pars: [4,3,4,3,5,5,4,3,5],
    index: [2,9,4,3,5,1,6,8,7]
  },

  "KELAB_GOLF_NEGARA_SUBANG_KELANA": {
    shortName: "KGNS-K",
    fullName: "Kelab Golf Negara Subang (Putra Course)",
    location: ["Subang", "Selangor", "Malaysia"],
    pars: [5,4,4,3,4,5,3,4,4, 4,5,4,3,4,3,4,5,4],
    index: [7,1,13,11,3,9,15,17,5, 10,12,4,18,2,8,14,16,6]
  },

  "KELAB_GOLF_NEGARA_SUBANG_PUTRA": {
    shortName: "KGNS-P",
    fullName: "Kelab Golf Negara Subang (Kelana Course)",
    location: ["Subang", "Selangor", "Malaysia"],
    pars: [4,4,4,3,5,4,4,3,4, 4,3,5,3,4,4,5,3,4],
    index: [5,13,3,15,1,11,9,17,7, 14,18,4,16,10,2,6,12,8]
  },

  "KELAB_GOLF_SERI_SELANGOR": {
    shortName: "KGSS",
    fullName: "Kelab Golf Seri Selangor",
    location: ["Shah Alam", "Selangor", "Malaysia"],
    pars: [4,4,3,4,5,5,4,3,4, 4,4,3,5,3,4,4,4,5],
    index: [9,1,7,5,15,13,3,17,11, 4,18,14,6,8,10,2,12,16]
  },

  "KELAB_GOLF_SULTAN_ABDUL_AZIZ_SHAH_PRESIDENT_ALAM_SHAH": {
    shortName: "KGSAAS-PAS",
    fullName: "Kelab Golf Sultan Abdul Aziz Shah (President + Alam Shah)",
    location: ["Shah Alam", "Selangor", "Malaysia"],
    pars: [4,3,4,4,5,3,4,4,5, 4,3,5,4,4,4,5,3,4],
    index: [8,14,12,4,16,10,18,2,6, 17,13,7,3,9,11,1,15,5]
  },

  "KELAB_GOLF_SULTAN_ABDUL_AZIZ_SHAH_PRESIDENT_SULTAN": {
    shortName: "KGSAAS-PS",
    fullName: "Kelab Golf Sultan Abdul Aziz Shah (President + Sultan)",
    location: ["Shah Alam", "Selangor", "Malaysia"],
    pars: [4,3,4,4,5,3,4,4,5, 4,5,3,4,4,3,5,4,4],
    index: [7,13,11,3,15,9,17,1,5, 14,2,10,16,12,18,8,4,6]
  },

  "KELAB_GOLF_SULTAN_ABDUL_AZIZ_SHAH_SULTAN_ALAM_SHAH": {
    shortName: "KGSAAS-SAS",
    fullName: "Kelab Golf Sultan Abdul Aziz Shah (Sultan + Alam Shah)",
    location: ["Shah Alam", "Selangor", "Malaysia"],
    pars: [4,5,3,4,4,3,5,4,4, 4,3,5,4,4,4,5,3,4],
    index: [13,1,9,15,11,17,7,3,5, 18,14,8,4,10,12,2,16,6]
  },

  "KELAB_RAHMAN_PUTRA_MALAYSIA": {
    shortName: "KRPM",
    fullName: "Kelab Rahman Putra Malaysia",
    location: ["Sungai Buloh", "Selangor", "Malaysia"],
    pars: [4,4,4,3,5,3,5,4,4, 4,5,4,3,4,5,4,4,3],
    index: [3,11,17,9,13,15,1,5,7, 6,2,16,14,4,8,12,10,18]
  },

  "KELAB_REKREASI_TENTERA_UDARA": {
    shortName: "KRTU",
    fullName: "Kelab Rekreasi Tentera Udara",
    location: ["Shah Alam", "Selangor", "Malaysia"],
    pars: [4,4,5,4,3,5,3,4,4, 5,3,4,4,4,4,5,3,4],
    index: [13,3,11,1,17,15,9,7,5, 10,16,4,6,14,8,12,18,2]
  },

  "KINRARA_GOLF_CLUB": {
    shortName: "KGC",
    fullName: "Kinrara Golf Club",
    location: ["Puchong", "Selangor", "Malaysia"],
    pars: [4,5,3,3,3,4,5,4,4, 5,4,3,4,5,4,4,3,5],
    index: [5,1,13,17,9,15,7,11,3, 8,16,18,4,6,10,12,14,2]
  },

  "KOTA_PERMAI_GOLF_AND_COUNTRY_CLUB": {
    shortName: "KPGCC",
    fullName: "Kota Permai Golf & Country Club",
    location: ["Shah Alam", "Selangor", "Malaysia"],
    pars: [5,4,4,3,4,3,5,4,4, 4,4,5,4,3,4,4,3,5],
    index: [17,5,3,11,15,7,13,1,9, 12,16,14,4,18,2,6,10,8]
  },

  "KUALA_KUBU_BARU_GOLF_AND_COUNTRY_CLUB": {
    shortName: "KKBGCC",
    fullName: "Kuala Kubu Baru Golf & Country Club",
    location: ["Kuala Kubu Bharu", "Selangor", "Malaysia"],
    pars: [4,4,3,4,5,4,3,3,5, 4,3,4,4,3,4,4,5,4],
    index: [5,7,13,15,1,11,17,9,3, 4,14,8,6,18,10,16,2,12]
  },

  "Kundang_Lakes_Country_Club": {
    shortName: "KLCC",
    fullName: "Kundang Lakes Country Club",
    location: ["Rawang", "Selangor", "Malaysia"],
    pars: [4,3,4,5,4,4,5,3,4, 5,3,4,5,4,3,4,4,4],
    index: [17,15,3,11,7,9,5,13,1, 18,16,4,6,10,12,8,14,2]
  },

  "LEMBAH_BERINGIN_GOLF_CLUB": {
    shortName: "LBGC",
    fullName: "Lembah Beringin Golf Club",
    location: ["Kuala Kubu Baru", "Selangor", "Malaysia"],
    pars: [4,5,4,3,4,4,5,3,4, 4,5,4,4,3,5,4,3,4],
    index: [9,5,7,17,1,3,11,13,15, 6,10,14,2,18,4,8,16,12]
  },

  "MONTEREZ_GOLF_AND_COUNTRY_CLUB": {
    shortName: "MGCC",
    fullName: "Monterez Golf & Country Club",
    location: ["Shah Alam", "Selangor", "Malaysia"],
    pars: [4,4,3,5,3,4,4,4,4, 5,4,3,5,4,3,4,4,4],
    index: [5,1,13,3,9,17,7,15,11, 2,14,12,18,8,16,6,10,4]
  },

  "PALM_GARDEN_GOLF_CLUB": {
    shortName: "PGGC",
    fullName: "Palm Garden Golf Club",
    location: ["Putrajaya", "Selangor", "Malaysia"],
    pars: [4,3,4,5,5,4,3,4,4, 5,4,3,5,3,5,4,3,4],
    index: [7,17,11,3,1,5,9,15,13, 10,14,18,2,8,6,16,12,4]
  },

  "PERANGSANG_TEMPLER_GOLF_CLUB": {
    shortName: "PTGC",
    fullName: "Perangsang Templer Golf Club",
    location: ["Rawang", "Selangor", "Malaysia"],
    pars: [4,5,4,3,4,3,4,4,5, 4,3,4,4,4,5,4,3,5],
    index: [7,15,3,17,11,13,1,9,5, 10,16,2,4,14,8,6,18,12]
  },

  "PORT_KLANG_GOLF_RESORT": {
    shortName: "PKGR",
    fullName: "Port Klang Golf Resort",
    location: ["Klang", "Selangor", "Malaysia"],
    pars: [5,4,3,5,3,4,4,4,4, 4,4,5,3,5,4,3,4,4],
    index: [11,7,17,3,13,5,15,1,9, 8,2,6,16,4,14,12,18,10]
  },

  "ROYAL_KAMPUNG_KUANTAN_CLUB": {
    shortName: "RKKC",
    fullName: "Royal Kampung Kuantan Club",
    location: ["Bukit Rotan", "Selangor", "Malaysia"],
    pars: [4,5,3,4,4,4,3,5,4, 4,3,5,3,5,4,4,3,4],
    index: [15,13,9,7,3,5,17,1,11, 2,16,8,6,12,4,14,18,10]
  },

  "SAUJANA_GOLF_AND_COUNTRY_CLUB_BUNGA_RAYA": {
    shortName: "SGCC-BR",
    fullName: "Saujana Golf & Country Club (Bunga Raya Course)",
    location: ["Shah Alam", "Selangor", "Malaysia"],
    pars: [5,4,4,4,4,3,5,4,4, 5,4,3,4,5,3,4,3,4],
    index: [13,7,1,3,5,17,11,15,9, 2,18,14,6,8,10,16,12,4]
  },

  "SAUJANA_GOLF_AND_COUNTRY_CLUB_PALM": {
    shortName: "SGCC-P",
    fullName: "Saujana Golf & Country Club (Palm Course)",
    location: ["Shah Alam", "Selangor", "Malaysia"],
    pars: [4,3,5,4,3,4,4,5,4, 4,4,3,5,4,4,3,4,5],
    index: [11,13,7,15,17,3,5,9,1, 10,6,16,18,2,4,14,12,8]
  },

  "SUNGAI_LONG_GOLF_AND_COUNTRY_CLUB": {
    shortName: "SLGCC",
    fullName: "Sungai Long Golf & Country Club",
    location: ["Kajang", "Selangor", "Malaysia"],
    pars: [4,5,3,4,5,4,4,3,4, 4,4,5,4,3,5,4,3,4],
    index: [17,9,5,1,3,11,15,13,7, 18,8,12,2,16,6,10,4,14]
  },

  "TASIK_PUTERI_GOLF_AND_COUNTRY_CLUB_PUTERA_TASIK": {
    shortName: "TPGCC-PT",
    fullName: "Tasik Puteri Golf & Country Club (Putera + Tasik)",
    location: ["Rawang", "Selangor", "Malaysia"],
    pars: [4,4,4,5,3,4,5,3,4, 4,5,4,3,4,3,4,4,5],
    index: [3,5,9,15,13,17,1,11,7, 12,6,2,10,14,18,16,4,8]
  },

  "TASIK_PUTERI_GOLF_AND_COUNTRY_CLUB_PUTERI_PUTERA": {
    shortName: "TPGCC-PP",
    fullName: "Tasik Puteri Golf & Country Club (Puteri + Putera)",
    location: ["Rawang", "Selangor", "Malaysia"],
    pars: [4,4,3,5,4,4,5,3,4, 4,4,4,5,3,4,5,3,4],
    index: [5,1,17,9,11,13,15,3,7, 4,6,10,16,14,18,2,12,8]
  },

  "TASIK_PUTERI_GOLF_AND_COUNTRY_CLUB_PUTERI_TASIK": {
    shortName: "TPGCC-PuT",
    fullName: "Tasik Puteri Golf & Country Club (Puteri + Tasik)",
    location: ["Rawang", "Selangor", "Malaysia"],
    pars: [4,4,3,5,4,4,5,3,4, 4,5,4,3,4,3,4,4,5],
    index: [6,2,18,10,12,14,16,4,8, 11,5,1,9,13,17,15,3,7]
  },

  "TEMPLER_PARK_COUNTRY_AND_GOLF_CLUB": {
    shortName: "TPCGC",
    fullName: "Templer Park Country & Golf Club",
    location: ["Rawang", "Selangor", "Malaysia"],
    pars: [5,3,4,4,4,4,5,3,4, 4,3,5,4,4,5,3,4,4],
    index: [11,15,1,7,5,17,13,9,3, 16,12,6,10,14,2,18,4,8]
  },

  "THE_CLUB_AT_BUKIT_UTAMA": {
    shortName: "TCBU",
    fullName: "The Club @ Bukit Utama",
    location: ["Bandar Utama", "Selangor", "Malaysia"],
    pars: [4,3,4,3,4,4,5,3,4],
    index: [2,9,1,7,8,6,3,5,4]
  },

  "THE_MINES_RESORT_AND_GOLF_CLUB": {
    shortName: "TMRGC",
    fullName: "The MINES Resort & Golf Club",
    location: ["Seri Kembangan", "Selangor", "Malaysia"],
    pars: [4,5,4,4,3,4,3,5,4, 4,3,5,4,4,4,3,4,4],
    index: [16,4,2,8,12,18,10,14,6, 9,11,13,1,5,17,15,3,7]
  },

  "TROPICANA_GOLF_COUNTRY_RESORT": {
    shortName: "TGCR",
    fullName: "Tropicana Golf Country Resort",
    location: ["Petaling Jaya", "Selangor", "Malaysia"],
    pars: [4,4,3,5,4,5,4,3,4, 4,4,4,3,5,4,4,3,5],
    index: [3,9,17,7,1,13,5,15,11, 10,8,14,18,6,2,4,12,16]
  },

  "UPM_GOLF_CLUB": {
    shortName: "UGC",
    fullName: "UPM Golf Club",
    location: ["Serdang", "Selangor", "Malaysia"],
    pars: [5,4,4,4,5,3,4,3,4, 4,3,4,4,4,4,5,3,5],
    index: [11,13,15,1,5,7,3,17,9, 4,16,6,8,14,10,2,12,18]
  },

  "VALENCIA_GOLF_CLUB": {
    shortName: "VGC",
    fullName: "Valencia Golf Club",
    location: ["Sungai Buloh", "Selangor", "Malaysia"],
    pars: [4,3,4,4,4,3,5,3,4],
    index: [2,8,9,3,4,6,7,5,1]
  }
};

export default SELANGOR_COURSES;
